import { CallIntelligenceService } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2';
import { DemoInterceptorUtils, DemoIdUtils, FeatureMockRouter } from '@frontend/demo-interceptors';
import { serviceName } from '../../service';
import * as CallIntelTypes from '../../types';
import { BaseMockRouterContext } from './types';

export type CallIntelOverviewMockRouterContext = BaseMockRouterContext;

export const CallIntelOverviewMockRouter: FeatureMockRouter<CallIntelOverviewMockRouterContext> = {
  getRequestInterceptors: ({ interceptorIdPrefix, vertical, hasVoiceAiAccess }) => [
    {
      id: `${interceptorIdPrefix}-call-overview`,
      interceptor: async (request: Request) => {
        const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
          schemaMethod: CallIntelligenceService.GetCallsOverview,
          requestUrl: request.url,
          method: request.method,
        });

        if (!isMatching) {
          return request;
        }

        const requestBody: CallIntelTypes.GetCallsOverviewIO['input'] = await request.clone().json();

        if (requestBody.isCallTrendDemo !== undefined) {
          const { personId: personIdList } =
            requestBody.filter?.[CallIntelTypes.FilterTypeEnum.FILTER_BY_PERSON_ID] ?? {};
          if (
            requestBody.filter &&
            requestBody.filter[CallIntelTypes.FilterTypeEnum.FILTER_BY_PERSON_ID] &&
            personIdList
          ) {
            requestBody.filter[CallIntelTypes.FilterTypeEnum.FILTER_BY_PERSON_ID].personId = personIdList.map((id) =>
              DemoIdUtils.removeDemoDataFromId(id)
            );
          }
          requestBody.isDemo = false;
          requestBody.isCallTrendDemo = true;
        } else {
          requestBody.isDemo = true;
        }

        requestBody.demoMetadata = {
          ...requestBody.demoMetadata,
          vertical,
          features: {
            enableCallIntelligence: true,
            enableVoiceAi: hasVoiceAiAccess,
          },
        };

        return new Request(request, {
          body: JSON.stringify(requestBody),
        });
      },
    },
    {
      id: `${interceptorIdPrefix}-call-overview-stats`,
      interceptor: async (request) => {
        const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
          schemaMethod: CallIntelligenceService.OverviewStats,
          requestUrl: request.url,
          method: request.method,
        });

        if (!isMatching) {
          return request;
        }

        const requestBody: CallIntelTypes.GetOverviewStatsIO['input'] = await request.clone().json();
        requestBody.isDemo = true;
        requestBody.demoMetadata = {
          ...requestBody.demoMetadata,
          vertical,
          features: {
            enableCallIntelligence: true,
            enableVoiceAi: hasVoiceAiAccess,
          },
        };

        return new Request(request, {
          body: JSON.stringify(requestBody),
        });
      },
    },
    {
      id: `${interceptorIdPrefix}-call-scheduling-stats`,
      interceptor: async (request) => {
        const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
          schemaMethod: CallIntelligenceService.GetSchedulingAggregateStats,
          requestUrl: request.url,
          method: request.method,
        });

        if (!isMatching) {
          return request;
        }

        const requestBody: CallIntelTypes.GetSchedulingAggregateStatsIO['input'] = await request.clone().json();
        requestBody.isDemo = true;

        requestBody.demoMetadata = {
          ...requestBody.demoMetadata,
          vertical,
          features: {
            enableCallIntelligence: true,
            enableVoiceAi: hasVoiceAiAccess,
          },
        };

        return new Request(request, {
          body: JSON.stringify(requestBody),
        });
      },
    },
    {
      id: `${interceptorIdPrefix}-call-view-by-location`,
      interceptor: async (request: Request) => {
        const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
          schemaMethod: CallIntelligenceService.GetCallsViewByLocation,
          requestUrl: request.url,
          method: request.method,
        });

        if (!isMatching) {
          return request;
        }

        const requestBody: CallIntelTypes.GetCallsOverviewIO['input'] = await request.clone().json();

        requestBody.isDemo = true;
        requestBody.demoMetadata = {
          vertical,
          features: {
            enableCallIntelligence: true,
            enableVoiceAi: hasVoiceAiAccess,
          },
        };
        return new Request(request, {
          body: JSON.stringify(requestBody),
        });
      },
    },
  ],
  invalidateQueries: (queryClient) => {
    queryClient.invalidateQueries([serviceName, 'GetCallsOverview']);
    queryClient.invalidateQueries([serviceName, 'GetCallsOverviewStats']);
    queryClient.invalidateQueries([serviceName, 'GetCallsViewByLocation']);
  },
};
